import {connect} from "react-redux";
import {update as updateDebug} from "@redux/slices/debug";
import {LocalisedTypography} from "@components/localisation/LocalisedTypography";
import {IDebug} from "@redux/slices/debug";
import {Update} from "@redux/slices/base";
import {ChangeEventHandler} from "react";
import {selectDebug} from "@redux/selectors/debug";

interface IDebugTabPanel {
    debug: IDebug,
    updateDebug: Update
}
function DebugTabPanel({debug, updateDebug}: IDebugTabPanel) {
    const handleChange = (label: string): ChangeEventHandler<HTMLInputElement> =>
        ({target}) => {
            updateDebug({update: target.checked, store: [label]});
        }

    return (
        <div>
            <div>
                <input onChange={handleChange("showAltitude")} type="checkbox"
                       checked={debug.showAltitude}/>
                <LocalisedTypography content="DebugShowAltitude"/>
            </div>
            <div>
                <input onChange={handleChange("showTileImage")} type="checkbox"
                       checked={debug.showTileImage}/>
                <LocalisedTypography content="DebugShowTileImage"/>
            </div>
        </div>
    );
}

const mapStateToProps = (store: never) => ({
    debug: selectDebug(store)
});
const connected = connect(mapStateToProps, {
    updateDebug
})(DebugTabPanel);
export {connected as DebugTabPanel}
